var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4037_1836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.43164 12.75C8.43164 13.1642 8.76743 13.5 9.18164 13.5C9.59585 13.5 9.93164 13.1642 9.93164 12.75H8.43164ZM8.43164 7.5C8.01743 7.5 7.68164 7.83579 7.68164 8.25C7.68164 8.66421 8.01743 9 8.43164 9V7.5ZM9.07181 8.35983L9.60214 7.8295L9.07181 8.35983ZM8.994 5.25C8.57978 5.25 8.244 5.58579 8.244 6C8.244 6.41421 8.57978 6.75 8.994 6.75V5.25ZM9.00073 6.75C9.41495 6.75 9.75073 6.41421 9.75073 6C9.75073 5.58579 9.41495 5.25 9.00073 5.25V6.75ZM17.25 9C17.25 4.44365 13.5563 0.75 9 0.75V2.25C12.7279 2.25 15.75 5.27208 15.75 9H17.25ZM9 0.75C4.44365 0.75 0.75 4.44365 0.75 9H2.25C2.25 5.27208 5.27208 2.25 9 2.25V0.75ZM0.75 9C0.75 13.5563 4.44365 17.25 9 17.25V15.75C5.27208 15.75 2.25 12.7279 2.25 9H0.75ZM9 17.25C13.5563 17.25 17.25 13.5563 17.25 9H15.75C15.75 12.7279 12.7279 15.75 9 15.75V17.25ZM8.43164 9V12.75H9.93164V9H8.43164ZM8.43164 9C8.52282 9 8.58985 9.00005 8.64646 9.00148C8.70344 9.00292 8.73124 9.00544 8.74318 9.00704C8.75464 9.00858 8.7306 9.00671 8.68981 8.98993C8.64303 8.97069 8.58948 8.93817 8.54148 8.89016L9.60214 7.8295C9.38464 7.61201 9.12834 7.54533 8.94305 7.52042C8.77934 7.49841 8.58721 7.5 8.43164 7.5V9ZM9.93164 9C9.93164 8.84443 9.93323 8.6523 9.91122 8.48859C9.88631 8.3033 9.81963 8.047 9.60214 7.8295L8.54148 8.89016C8.49347 8.84216 8.46096 8.78861 8.44171 8.74183C8.42493 8.70104 8.42306 8.677 8.4246 8.68846C8.4262 8.7004 8.42873 8.7282 8.43016 8.78518C8.43159 8.84179 8.43164 8.90882 8.43164 9H9.93164ZM8.994 6.75H9.00073V5.25H8.994V6.75Z",
    fill: "#737373"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4037_1836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/about-icon.47b295d2e2fa5141c59f11ff6e55661d.svg";
export { ForwardRef as ReactComponent };